import React from 'react';
import $ from 'jquery';
import ContestLanding from '../common/ContestLanding';
import HmEventRegistry from '../../model/HmEventRegistry';
import ComponentRegistry from '../../model/ComponentRegistry';

export default class ContestInstruction extends ContestLanding {
  constructor(props) {
        super(props);
        this.state = {
        
        };
        this.dashboardDropDownKey = "homeDropdown";
        this.setChild(this,"CONTEST");

    }
    
    componentDidMount(){
        super.componentDidMount();
        HmEventRegistry.fireEvent("INITIATE_GA");
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    }


    render() {
        return super.render(
          <div className="HomeComponent" id="ContestInstruct">
          <h4>Instructions</h4>
            <div className="instruct-content">
            <ul>
                <li>Go to the Contest tab and click on 'Start' under {this.rb("title.ri")} Mock Contest / {this.rb("title.ri23")}.</li>
                <li>Click 'Start' in the {this.rb("title.ri")} Mock Contest dialog box to begin taking the test.</li>
                <li>There are 20 multiple-choice questions.</li>
                <li>
                    <div>
                        <div>The mark allocation will be as follows:</div>
                        <table class="faq-table">
                        <tr>
                            <th>Question number</th>
                            <th>Correct</th>
                            <th>Unanswered</th>
                            <th>Incorrect</th>
                        </tr>
                        <tr>
                            <td>1 - 10</td>
                            <td>4</td>
                            <td>1</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>11 - 20</td>
                            <td>6</td>
                            <td>1</td>
                            <td>0</td>
                        </tr>
                        </table> 
                    </div>
                </li>
                <li>Duration of the test is 60 minutes.</li>
                <li>Calculators and mathematical set are not allowed.</li>
                <li>A timer will appear on the title bar at the top of the webpage, which will show you how much remaining time you have for the test.</li>
                <li>Select the relevant option to indicate your answer. If you click on the selected option again, it will deselect your answer.</li>
                <li>At the bottom of the page, the NEXT button will take you to the next question. You can also click on the question number to directly navigate to that specific question.</li>
                <li>Click the 'SAVE' button to keep saving your work. The answers get automatically saved when you move to the next question.</li>
                <li>On completing the test, click on the 'SUBMIT TEST'. <br /> Note that the 'SUBMIT TEST' button will be clickable only after all the questions have been viewed.</li>
                <li>On submission of the test, you will view a confirmation message.</li>
                <li>If the timer runs out (i.e, completion of 60 minutes) and you have not clicked on the 'SUBMIT TEST', your test will be automatically submitted and you will see the message 'Your time for the test has ended. Your answers have been successfully submitted'.</li>
                <li>Do NOT close the browser before submitting the test. Also do NOT refresh/reload the browser or hit the back button during the test.</li>
                <li>Do NOT open other tabs or browsers apart from the one you are using for the test.</li>
                <li>If your computer hangs or your browser closes during the test, you can re-login to the website and continue taking the test. Your saved answers will be automatically retrieved and you will have the remaining time (from when you were disconnected) to finish the test.</li>
           </ul>
            
            </div>
         </div>
      )
  }

}

ComponentRegistry.register("ri_ContestInstruction",ContestInstruction);


// WEBPACK FOOTER //
// ./src/views/contest/ContestInstruction.js